import React, {useEffect, useState} from 'react'
import Img from 'gatsby-image'
import Right from '../../assets/icons/chevron-right.svg'
import Left from '../../assets/icons/chevron-left.svg'
import ReactPlayer from 'react-player/lazy'
import Vimeo from '@u-wave/react-vimeo';

const Gallery = ({data}) => {

  const {gallery, photos} = data

  const [imageGroup, setImageGroup] = useState([])
  const [catGroup, setCatGroup] = useState([])
  const [showAll, setShowAll] = useState(false)

  useEffect(() => {
    if (gallery) {
      setImageGroup(gallery.reduce((a, b) => a.concat(b.media ? [...b.media.map(item => {
        item.cat = b.title
        return item
      })] : [...b.videos.map(item => {
        item.cat = b.title
        return item
      })]), []))
      setCatGroup(gallery.map(item => item.title))
    } else {
      if (photos) {
        setImageGroup(photos)
      }
    }
  }, [gallery])

  const handleChange = (e) => {
    if (gallery) {
      setImageGroup(gallery.filter(item => !e || item.title === e).reduce((a, b) => a.concat(b.media ? [...b.media.map(item => {
        item.cat = b.title
        return item
      })] : [...b.videos.map(item => {
        item.cat = b.title
        return item
      })]), []))
    }
  }

  const toggleShowAll = (e) => {
    setShowAll(true)
  }

  const [showImage, setShowImage] = useState(false);
  const [image, setImage] = useState();
  const [imageIndex, setImageIndex] = useState();

  const handleShowImageModal = (photo, index) => {
    setShowImage(!showImage);
    setImage(photo)
    setImageIndex(index)
  }

  return (
    <section className="photo-gallery">
      {!photos && (
        <GalleryFilters categories={catGroup} changeCategory={handleChange}/>
      )}
      <div className="photo-grid">
        {imageGroup ? imageGroup.map((photo, index) => {
          if (!showAll && index > 11) {
            return null
          }
          return (
            <div className="photo-grid-item" key={`media-${index}`}>
              <a onClick={(e) => handleShowImageModal(photo, index)}>
                {photo.localFile ? (
                  <Img fixed={photo?.localFile?.childImageSharp?.fixed}/>
                ) : photo.videoUrl ? (
                  <Vimeo
                    video={photo.videoUrl}
                    className='react-player'
                    width='400px'
                    height='y'
                    showTitle
                    showByline
                    light={true}
                    style={{pointerEvents: 'none'}}
                  />
                ) : null}

              </a>
            </div>
          )
        }) : ''}
      </div>
      {!showAll ? (
        <button className="btn button-solid" onClick={(e) => toggleShowAll()}>Load More</button>
      ) : ''}
      <ImageModal showImage={showImage} hide={handleShowImageModal} photo={image} photos={imageGroup}
                  index={imageIndex}/>
    </section>
  )
}

const ImageModal = ({showImage, hide, photos, index}) => {

  const [imageIndex, setImageIndex] = useState(0)

  useEffect(() => {
    if (index) {
      setImageIndex(index)
    }
  }, [index])

  useEffect(() => {
    if (typeof window !== undefined) {
      const onKeyUp = ({key}) => {
        if (key === 'ArrowLeft') {
          handleDecrement()
        }
        if (key === 'ArrowRight') {
          handleIncrement()
        }
      }
      document.addEventListener('keyup', onKeyUp);
      return () => {
        document.removeEventListener('keyup', onKeyUp);
      }
    }
  }, [imageIndex]);

  const handleIncrement = (e) => {
    if (e) {
      e.stopPropagation()
    }
    if (imageIndex < photos.length - 1) {
      setImageIndex(prevCount => prevCount + 1);
    }
  };

  const handleDecrement = (e) => {
    if (e) {
      e.stopPropagation()
    }
    if (imageIndex > 0) {
      setImageIndex(prevCount => prevCount - 1);
    }
  };

  if (!showImage) {
    return null;
  }

  return (
    <div className="overlay lightbox" onClick={hide}>
      {photos[imageIndex].localFile ? (
        <div className="image">
          <button className="prev-arrow" onClick={(e) => handleDecrement(e)}>
            <img alt="" src={Left}/>
          </button>
          {imageIndex !== null ? (
            <Img fluid={photos[imageIndex]?.localFile?.childImageSharp?.fluid}/>
          ) : ''}
          <button className="next-arrow" onClick={(e) => handleIncrement(e)}>
            <img alt="" src={Right}/>
          </button>
        </div>
      ) : (
        <div className="image">
          <button className="prev-arrow" onClick={(e) => handleDecrement(e)}>
            <img alt="" src={Left}/>
          </button>
          {imageIndex !== null ? (
            <ReactPlayer
              url={photos[imageIndex].videoUrl}
              className='react-player'
              width='100%'
              height='100%'
              controls={true}
            />
          ) : ''}
          <button className="next-arrow" onClick={(e) => handleIncrement(e)}>
            <img alt="" src={Right}/>
          </button>
        </div>
      )}
    </div>
  )
}

const GalleryFilters = ({categories, changeCategory}) => {

  const [selectedCat, setSelectedCat] = useState(null)

  const handleCatChange = (name) => {
    setSelectedCat(name)
    changeCategory(name)
  }

  return (
    <div className="filter-row">
      <a onClick={(e) => handleCatChange(null)} className={`filter-btn ${selectedCat === null ? 'active' : ''}`}>
        All
      </a>
      {categories ? categories.map((cat, index) => {
        return (
          <a key={`filter-${index}`} onClick={(e) => handleCatChange(cat)}
             className={`filter-btn ${selectedCat === cat ? 'active' : ''}`}>
            {cat}
          </a>
        )
      }) : ''}
    </div>
  )
}

export default Gallery
